import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { SettingsRootParamList } from "../../../../types";
import { Button, Page, View } from "@towersystems/roam-common-native";
import { LinklyPairForm } from "../../components/LinklyPairForm/LinklyPairForm";
import React from "react";
import { LinklyPairFormValues } from "../../components/LinklyPairForm/types";
import { useFormContext } from "react-hook-form";
import { useMutation } from "@apollo/client";
import { PairLinklyPinpadResult } from "@towersystems/roam-common/lib/generated-types";
import { useActiveTerminal } from "../../../../utilities/app-state/hooks";
import { useLinklyPosContext } from "../../../../utilities/linkly";
import { MUTATION_LINKLY_PAIR_PINPAD } from "../../common/constants";

export type LinklyPairPinpadScreenProps = NativeStackScreenProps<
  SettingsRootParamList,
  "LinklyPairPinpadScreen"
>;

const LinklyPairPinpad = ({
  navigation,
  route,
}: LinklyPairPinpadScreenProps) => {
  const linklySDKContext = useLinklyPosContext();

  const [m] = useMutation<{ pairPinpad: PairLinklyPinpadResult }>(
    MUTATION_LINKLY_PAIR_PINPAD
  );

  const { formState, setError, handleSubmit } =
    useFormContext<LinklyPairFormValues>();

  const { isValid, isDirty } = formState;

  const handleOnValidSubmit = React.useCallback(
    async ({ paymentMethodId, ...input }: LinklyPairFormValues) => {
      return m({
        variables: {
          input,
          paymentMethodId,
        },
      })
        .then((response) => {
          const result = response.data?.pairPinpad;
          if (!result) {
            throw new Error("");
          }
          if ("errorCode" in result) {
            if (result.errorCode === "INVALID_LINKLY_CREDENTIALS_ERROR") {
              setError("password", {
                type: "400",
                message: "Invalid Credentials",
              });
              return;
            }
            throw new Error("");
          } else if ("secret" in result) {
            linklySDKContext.methods.setPairSecret(result.secret);
            navigation.goBack();
            return;
          } else {
            throw new Error("");
          }
        })
        .catch((err) => {
          setError("root.serverError", {
            type: "400",
            message: "Something went wrong.",
          });
        });
    },
    []
  );

  React.useEffect(() => {
    navigation.setOptions({
      headerRight: () => (
        <Button
          label="Save"
          isAction
          disabled={!isValid}
          onPress={handleSubmit(handleOnValidSubmit, console.log)}
          size="compact"
        ></Button>
      ),
    });
  }, [isValid, isDirty]);

  return (
    <Page title="Pair New Pinpad">
      <LinklyPairForm />
    </Page>
  );
};

export const LinklyPairPinpadScreen = ({
  ...props
}: LinklyPairPinpadScreenProps) => {
  const { terminal } = useActiveTerminal();
  if (!terminal) return <View />;
  return (
    <LinklyPairForm.LinklyPairFormProvider
      defaultValues={{
        paymentMethodId: props.route.params.paymentMethodId,
        name: terminal.name,
      }}
    >
      <LinklyPairPinpad {...props} />
    </LinklyPairForm.LinklyPairFormProvider>
  );
};
